import { createStyles, makeStyles } from '@material-ui/core/styles'

import { StyleProps } from './index'

export const useStyles = makeStyles((theme) =>
  createStyles({
    menuItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 600,
      lineHeight: '3.2rem',
      color: theme.palette.text.primary,
      backgroundColor: ({ isOpen }: StyleProps) =>
        isOpen ? theme.palette.background.default : 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
      },
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.body1.fontSize,
    },
    popper: {
      zIndex: theme.zIndex.modal + 2,
      paddingLeft: theme.spacing(1),
      minWidth: ({ minWidth }: StyleProps) => minWidth || '27.8rem',
    },
    paper: {
      padding: `${theme.spacing(1)} 0`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      borderRadius: theme.shape.borderRadius,
    },
  }),
)
